import { createEntityAdapter, EntityState } from '@ngrx/entity';

export type LabelLanguage = 'en' | 'es' | 'pt' | 'fr' | 'it';

export interface LabelAlias {
  id: string;
  name: string;
  language: LabelLanguage;
}

export interface Label {
  id: string;
  aliases: Record<LabelLanguage, LabelAlias>;
}

export const protocolLabelAdapter = createEntityAdapter<Label>();
